import Http from "@/services/http";

export default class APIModel {
  protected readonly http = new Http();
}
